export default function appReducer(state, action, setItem) {
  switch (action.type) {
    case 'SET_USER': {
      setItem('user', action.payload);
      return { ...state, user: action.payload };
    }

    case 'SET_ADMIN_TYPE': {
      setItem('adminType', action.payload);
      return { ...state, adminType: action.payload };
    }

    case 'SET_ACTIVE_TAB': {
      return { ...state, activeTab: action.payload };
    }

    case 'SET_POP_NOTIF': {
      return { ...state, notifications: action.payload };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
